var _style, _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShellsLogoVerticalWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2048 2048",
    style: {
      enableBackground: "new 0 0 2048 2048"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#04222E;}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_1_);}\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_2_);}\n\t.st5{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_3_);}\n\t.st6{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_4_);}\n\t.st7{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_5_);}\n\t.st8{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_6_);}\n\t.st9{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_7_);}\n\t.st10{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_8_);}\n\t.st11{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_9_);}\n\t.st12{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_10_);}\n\t.st13{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_11_);}\n\t.st14{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_12_);}\n\t.st15{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_13_);}\n\t.st16{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_14_);}\n\t.st17{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_15_);}\n\t.st18{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_16_);}\n")), /*#__PURE__*/React.createElement("g", {
    id: "b79faa2e-60de-46d4-b8de-b5c004f8a287"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ac31bbef-2f8d-45cb-9999-5757433c12c9"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 2048,
    height: 2048
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M389.8,1674.3l18.1-40.4c24,12.6,50.6,19.7,77.7,20.8c18.4,0,27.1-7,27.1-16.1c-0.2-5.4-3.2-10.3-7.8-12.9 c-10.4-5.7-21.5-9.9-33-12.6c-18.7-4.3-36.6-11.6-53-21.6c-15.3-9.8-24.4-26.9-23.9-45.1c0.3-16.4,7.9-31.9,20.8-42.1 c16.9-13.1,38-19.5,59.3-18c30.9,1,61.4,8.2,89.5,21.2l-18.1,40.4c-23.1-10.1-47.8-16-73-17.7c-16.9,0-25.5,6.7-25.5,15.7 c0,9.4,7.5,14.9,38.5,23.9c19.6,4.7,38.2,12.5,55.3,23.2c16,9,25.3,26.4,23.9,44.7c-0.4,16.9-8.5,32.6-22,42.8 c-17.5,13-39.1,19.4-60.8,18C450.3,1698.5,418.2,1690.2,389.8,1674.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M798.4,1548.3v147.1h-54.9v-129c0-20.8-7.8-31.4-31-31.4c-18.8,0.9-37.1,5.9-53.8,14.5v146h-55v-291.6h54.9 v104.4c23.2-13.5,49.3-21,76.1-22C777.2,1486.3,798.4,1507.1,798.4,1548.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1032.2,1615.9H889c4.9,25.1,27.9,42.4,53.4,40c21.8-0.7,43.3-5.8,63.2-14.9l17.3,38.1 c-26.8,12.9-56.2,19.6-86,19.6c-28,1.1-55.2-9.5-75-29.4c-19.5-20.8-29.8-48.5-28.7-76.9c-1.2-28.3,9.1-56,28.7-76.5 c19.7-19.8,46.7-30.4,74.5-29.4c27.6-1.8,54.3,10.1,71.4,31.8c17,23.5,25.6,52.1,24.4,81.2V1615.9z M887.4,1578.1H982 c-3.5-33-18.4-49.5-45.5-49.5C909.5,1529.4,887.9,1551.2,887.4,1578.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1069.5,1638.2v-234.3h54.9v226.4c0,13,6.3,19.6,18.4,19.6c3.9,0,8.6-0.4,13.7-0.8l3.5,46.7 c-9.8,1.8-19.8,2.8-29.8,2.7c-30.9,2.7-58-20.1-60.7-51C1069.2,1644.5,1069.2,1641.3,1069.5,1638.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1190.7,1638.2v-234.3h54.9v226.4c0,13,6.3,19.6,18.4,19.6c3.9,0,8.6-0.4,13.7-0.8l3.5,46.7 c-9.8,1.8-19.8,2.8-29.8,2.7c-30.8,2.7-58.1-20.1-60.8-50.9C1190.5,1644.5,1190.5,1641.3,1190.7,1638.2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1301.4,1674.3l18.1-40.4c24,12.6,50.6,19.7,77.7,20.8c18.4,0,27.1-7,27.1-16.1c-0.2-5.4-3.2-10.3-7.8-12.9 c-10.3-5.7-21.4-9.9-33-12.6c-18.7-4.3-36.6-11.6-53-21.6c-15.3-9.8-24.4-26.9-24-45.1c0.3-16.4,7.9-31.8,20.8-42 c16.9-13.1,38-19.5,59.3-18c30.9,1,61.4,8.2,89.5,21.2L1458,1548c-23.1-10.1-47.8-16-73-17.7c-16.9,0-25.5,6.7-25.5,15.7 c0,9.4,7.5,14.9,38.5,23.9c19.6,4.7,38.2,12.5,55.3,23.2c16,9,25.3,26.4,23.9,44.7c-0.4,16.9-8.5,32.6-22,42.8 c-17.5,13-39.1,19.4-60.8,18C1361.8,1698.6,1329.8,1690.2,1301.4,1674.3z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1564.3,1373v10.1h-29.7v78.3h-10.7v-78.3h-29.6V1373H1564.3z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1658.2,1461.4h-10.5l-2.6-71.4l-23.5,49.9c-0.9,2.1-2.9,3.5-5.2,3.4c-2.3,0.1-4.4-1.3-5.2-3.4l-23.6-49.7 l-2.6,71.1h-10.5l2.9-81.9c0-4.1,3.3-7.4,7.4-7.4c0.1,0,0.2,0,0.3,0c3-0.3,5.8,1.4,7.1,4.1l24.2,51.5l24-51.5 c1.3-2.7,4.1-4.3,7.1-4.1c4.1-0.1,7.5,3.1,7.7,7.2c0,0,0,0.1,0,0.1L1658.2,1461.4z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M809.3,964.4C732.9,903.9,685.5,814,678.7,716.8c-3.7-62.4,10.8-124.5,41.7-178.8 c68-115.1,190.5-187.1,324.2-190.4c97.4-4.5,193.3,25.9,270.3,85.6l18.8,15c5.5,4.4,9.1,10.8,10,17.8c1.1,7.1-1.2,14.2-6.1,19.4 L1234.6,603c12.3,10.7,23.9,23.4,34.8,34.8c119.5,121.5,135.6,298.6,32.2,428.4c-137.2,171.7-397.8,196-567.8,60.5l-18.8-15 c-11.1-8.9-12.9-25-4.1-36.2l0.3-1L809.3,964.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 1107.6993,
    y1: 203.5007,
    x2: 914.4706,
    y2: -57.9269,
    gradientTransform: "matrix(1 5.462853e-03 5.462853e-03 -1 -42.1178 820.2526)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#52BD15"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A0E35D"
    }
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1176.8,600.5l113.9-130.9c-68.2-52.4-152.7-79.2-238.7-75.5C873.1,401.9,722.3,539,731.8,712.8 c7.8,99.5,63.9,188.9,150.2,239.2c44.1,26.4,94.9,39.6,146.3,37.9c115-4.7,212.6-84.6,219.1-196c5-102.9-78.1-208.2-194-190.5 c-70.9,10.9-129.6,64-130.8,134.4c-0.3,42.3,19.3,82.4,53,108l9-10.6l20-23.9c-15.6-13.9-24.3-34-24-54.9 c1.3-45.2,38.8-80.9,84-79.9c53.7,2.6,95.3,48.1,93.2,101.8c0,4-0.5,8-1.6,11.9c-9.2,56.3-58.2,97.5-115.3,96.7 c-28.9,1-57.4-7.3-81.1-23.8c-39.7-30.3-63.2-77.2-63.7-127.2c0-14.5,2.2-28.9,6.5-42.8c4.1-13.4,10-26.1,17.5-37.9 c7.5-11.9,16.4-22.7,26.6-32.3c10.3-9.7,21.8-18.3,34.1-25.3c12.6-7.2,26-13,39.9-17.2c14.3-4.4,29.1-7.1,44.1-8.1 c19.4-0.9,38.9,1.3,57.6,6.4C1141.5,583.4,1159.8,590.7,1176.8,600.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 1030.5668,
    y1: -271.2525,
    x2: 1330.6396,
    y2: 62.9187,
    gradientTransform: "matrix(1 5.462853e-03 5.462853e-03 -1 -42.1178 820.2526)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#52BD15"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A0E35D"
    }
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M867.7,975.5L769.4,1089c68.4,53.6,154,80.7,240.8,76.1c100.5-1.9,195.1-48,258.5-126.1l2-2.7 c22.8-28.9,39.9-62,50.2-97.3c20-97.3-10.1-198.1-80.2-268.5c31.7,49.1,41.3,109.3,26.6,165.9c-26.6,107.2-126,175.3-238.6,179.6 C972.3,1019,916.1,1004.9,867.7,975.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 1322.9802,
    y1: 45.2101,
    x2: 974.513,
    y2: -264.8162,
    gradientTransform: "matrix(0.9997 2.504286e-02 2.504286e-02 -0.9997 -69.6047 829.7446)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#134A00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#134A00",
      stopOpacity: 0
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M769.5,1089c78.6,60.9,178.6,87.3,277.1,73.2l3.4-147.9c-63.4,7.2-127.3-6.4-182.3-38.8L769.5,1089z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 1161.6958,
    y1: 82.8629,
    x2: 875.5287,
    y2: -20.192,
    gradientTransform: "matrix(1 8.000000e-03 8.000000e-03 -1 -51.024 824.521)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#134A00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#134A00",
      stopOpacity: 0
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M738.7,757.3c19,83.7,72.6,155.4,147.5,197.3L962,865c-37-27.4-60.7-69.3-65.1-115.2L738.7,757.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 927.2888,
    y1: 19.0998,
    x2: 971.075,
    y2: 348.3773,
    gradientTransform: "matrix(1 5.462853e-03 5.462853e-03 -1 -42.1178 820.2526)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#134A00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#134A00",
      stopOpacity: 0
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M927,645c31.7-41,79-67.1,130.6-72.1l-1.4-178.8C947.9,397.2,847,449.9,782.5,537L927,645z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 982.2792,
    y1: -91.8841,
    x2: 834.6389,
    y2: 203.3759,
    gradientTransform: "matrix(1 5.462853e-03 5.462853e-03 -1 -42.1178 820.2526)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#134A00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#134A00",
      stopOpacity: 0
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M927.2,644.9l-144.6-108c-45.6,63.7-61.6,144-43.9,220.3l158.2-7.5C893.5,712.3,904.3,674.9,927.2,644.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 970.0959,
    y1: 247.399,
    x2: 1096.8058,
    y2: 108.729,
    gradientTransform: "matrix(1 5.462853e-03 5.462853e-03 -1 -42.1178 820.2526)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1210.4,670.9c-35.1-50.7-96.1-76.8-157.1-67.3c-70.9,10.9-129.6,64-130.8,134.4c-0.3,42.3,19.3,82.4,53,108 l5.3-6.1c-43.9-48.9-46.2-132.8,6.5-171c89.3-64.6,194.8-11.6,227.3,83.1c10.6,34.1,17,69.4,19.1,105 C1258.1,795.1,1249.2,725,1210.4,670.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 1191.1653,
    y1: 39.7623,
    x2: 1201.6511,
    y2: -296.314,
    gradientTransform: "matrix(0.9999 -1.272311e-02 -1.272311e-02 -0.9999 -23.0072 813.8746)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#134A00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#134A00",
      stopOpacity: 0
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M1046.5,1162.2c85-10.5,162.8-52.8,218-118.2l4.2-5c19.7-24.6,35.3-52.2,46.3-81.7l-71.3-62.3 c-42.6,67.6-114.2,111.7-193.8,119.2L1046.5,1162.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 1179.4929,
    y1: 177.2887,
    x2: 1392.0139,
    y2: -89.135,
    gradientTransform: "matrix(1 5.462853e-03 5.462853e-03 -1 -42.1178 820.2526)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#134A00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#134A00",
      stopOpacity: 0
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M1243.7,895.1l71.3,62.3c1.3-4.1,4.4-13.3,5.7-17.3c20.5-97.5-9.5-198.8-79.8-269.4 c31.8,49.5,41.7,110.1,27.2,167.1C1262,857.6,1253.8,876.8,1243.7,895.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 1476.2185,
    y1: -609.1382,
    x2: 1085.9105,
    y2: -101.4395,
    gradientTransform: "matrix(1 5.462853e-03 5.462853e-03 -1 -42.1178 820.2526)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M769.5,1089c68.4,53.6,153.9,80.7,240.7,76.1c100.5-2,195-48.1,258.5-126.1l2-2.7 c22.8-28.9,39.9-62,50.2-97.3c3-12.2,4.7-24.7,5.2-37.3c0.9-12.5,1-25.1,0.3-37.6c-3.6-72.8-34-141.7-85.4-193.4 c2.8,3.5,5.2,7.2,7.4,11.1c16.5,23.3,30,48.6,40.2,75.2c9.7,26,15.2,53.5,16.2,81.2v0.8v2.5c0.3,12-0.1,23.9-1.3,35.8 c-0.8,11.8-2.7,23.6-5.6,35.1c-9.6,32.6-25.4,63-46.7,89.5l-2,2.7c-59,71.4-146,114-238.6,116.7c-76.4,3.2-151.7-19.5-213.6-64.5 L769.5,1089z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 1270.1587,
    y1: 154.9958,
    x2: 869.2422,
    y2: -472.9617,
    gradientTransform: "matrix(1 5.462853e-03 5.462853e-03 -1 -42.1178 820.2526)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#134A00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#134A00",
      stopOpacity: 0
    }
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M1007.9,1049.7c124.1-5.1,232.6-80.4,261.1-197.1c18.9-61.8,8.5-128.8-28.1-182.1 c31.3,49.3,40.9,109.3,26.6,165.9c-26.6,107.2-124.5,174.5-238.6,179.6c-56.5,2.3-112.5-11.7-161.2-40.5l-29.2,33.5 C890.1,1038.1,948.8,1052.1,1007.9,1049.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 1021.6937,
    y1: 103.3236,
    x2: 1208.9219,
    y2: 387.9336,
    gradientTransform: "matrix(1 5.462853e-03 5.462853e-03 -1 -42.1178 820.2526)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#134A00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#134A00",
      stopOpacity: 0
    }
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M1057.8,572.9l-1.3-178.9c84.5-2.5,167.2,24.3,234.3,75.8l-113.9,130.9 C1140.7,579.8,1099.3,570.2,1057.8,572.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 1742.8276,
    y1: -334.2427,
    x2: 1340.5389,
    y2: -187.8722,
    gradientTransform: "matrix(0.9522 0.3056 0.3056 -0.9522 -186.1235 209.9146)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#134A00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#134A00",
      stopOpacity: 0
    }
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M1237.6,844.7c-5.8,15.4-12.8,30.3-21.2,44.4c-19.2,29.3-45.6,53.4-76.5,69.9 c-30.2,16.9-63.8,27.1-98.3,29.9c-29.8,2.4-59.8-0.1-88.9-7.3c-6.1-1.5-12.2-3.2-18.2-5.2c-18.6-6.2-36.5-14.5-53.2-24.6 c-17-10-32.9-21.6-47.5-34.8c-14-12.1-26.7-25.6-37.9-40.3c-2.2-2.9-4.3-5.9-6.3-8.9c-2.1-3.2-4.4-6.2-6.8-9.1 c12.3,14,26,26.7,40.9,37.9c8.3,6.4,17.1,12.3,26.1,17.7c4.1,2.5,8.2,4.9,12.5,7c5.4,3,11.2,5.7,17,8.2c3.1,1.5,6.4,2.7,9.7,4.1 c5.5,2.2,11.2,4.3,16.9,6.1c4.3,1.4,8.6,2.6,12.9,3.8c8.4,2.3,17,4.1,25.6,5.5c38.2,6.4,77.4,4.3,114.7-6c1.6-0.4,3.2-0.8,4.6-1.2 c6.5-1.7,12.9-3.8,19.1-6.3c0.2,0,0.5-0.1,0.6-0.2c88.1-35.6,130.7-135.8,95.2-223.9c-14.3-35.4-40-65.1-73-84.3 c-10.7-6.3-22-11.4-33.8-15.1l-0.8-0.2c-9.3-3-18.9-5.1-28.7-6.4c6.5-1.6,13.3-1.9,19.9-2.9c14.6-1.2,29.2-0.7,43.7,1.4 c4.8,1.1,10,1.7,14.7,3.2c19.8,6,38.4,15.4,54.9,27.9c3.3,2.6,8.3,6.8,11.4,9.7c3.6,3.2,6.9,6.6,10.1,10.2 c0.7,0.7,2.7,2.9,3.3,3.7c25,29.3,41,65.2,46.1,103.3c1.3,9,1.7,18.2,1.2,27.3C1246.8,808.2,1243.4,826.8,1237.6,844.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 771.5599,
    y1: 319.4807,
    x2: 1072.6365,
    y2: 148.7395,
    gradientTransform: "matrix(1 5.462853e-03 5.462853e-03 -1 -42.1178 820.2526)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M1290.7,469.7c-68.2-52.4-152.7-79.2-238.7-75.5C873.1,401.9,722.3,539,731.8,712.8 c7.8,99.5,63.9,188.9,150.2,239.2c33.6,20.2,71.2,32.9,110.1,37.2c10.1,0.9,20.2,1.4,30.4,1.2C896.9,986.1,789,873.9,781.9,749.2 C773.4,597,906.1,477.7,1061,471.3c65.3-2.4,129.8,14.9,185.1,49.7L1290.7,469.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 1742.8276,
    y1: -334.2427,
    x2: 1340.5389,
    y2: -187.8722,
    gradientTransform: "matrix(0.9522 0.3056 0.3056 -0.9522 -186.1235 209.9146)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#134A00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#134A00",
      stopOpacity: 0
    }
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M1237.6,844.7c-5.8,15.4-12.8,30.3-21.2,44.4c-19.2,29.3-45.6,53.4-76.5,69.9 c-30.2,16.9-63.8,27.1-98.3,29.9c-29.8,2.4-59.8-0.1-88.9-7.3c-6.1-1.5-12.2-3.2-18.2-5.2c-18.6-6.2-36.5-14.5-53.2-24.6 c-17-10-32.9-21.6-47.5-34.8c-14-12.1-26.7-25.6-37.9-40.3c-2.2-2.9-4.3-5.9-6.3-8.9c-2.1-3.2-4.4-6.2-6.8-9.1 c12.3,14,26,26.7,40.9,37.9c8.3,6.4,17.1,12.3,26.1,17.7c4.1,2.5,8.2,4.9,12.5,7c5.4,3,11.2,5.7,17,8.2c3.1,1.5,6.4,2.7,9.7,4.1 c5.5,2.2,11.2,4.3,16.9,6.1c4.3,1.4,8.6,2.6,12.9,3.8c8.4,2.3,17,4.1,25.6,5.5c38.2,6.4,77.4,4.3,114.7-6c1.6-0.4,3.2-0.8,4.6-1.2 c6.5-1.7,12.9-3.8,19.1-6.3c0.2,0,0.5-0.1,0.6-0.2c88.1-35.6,130.7-135.8,95.2-223.9c-14.3-35.4-40-65.1-73-84.3 c-10.7-6.3-22-11.4-33.8-15.1l-0.8-0.2c-9.3-3-18.9-5.1-28.7-6.4c6.5-1.6,13.3-1.9,19.9-2.9c14.6-1.2,29.2-0.7,43.7,1.4 c4.8,1.1,10,1.7,14.7,3.2c19.8,6,38.4,15.4,54.9,27.9c3.3,2.6,8.3,6.8,11.4,9.7c3.6,3.2,6.9,6.6,10.1,10.2 c0.7,0.7,2.7,2.9,3.3,3.7c25,29.3,41,65.2,46.1,103.3c1.3,9,1.7,18.2,1.2,27.3C1246.8,808.2,1243.4,826.8,1237.6,844.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 771.5599,
    y1: 319.4807,
    x2: 1072.6365,
    y2: 148.7395,
    gradientTransform: "matrix(1 5.462853e-03 5.462853e-03 -1 -42.1178 820.2526)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M1290.7,469.7c-68.2-52.4-152.7-79.2-238.7-75.5C873.1,401.9,722.3,539,731.8,712.8 c7.8,99.5,63.9,188.9,150.2,239.2c33.6,20.2,71.2,32.9,110.1,37.2c10.1,0.9,20.2,1.4,30.4,1.2C896.9,986.1,789,873.9,781.9,749.2 C773.4,597,906.1,477.7,1061,471.3c65.3-2.4,129.8,14.9,185.1,49.7L1290.7,469.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShellsLogoVerticalWhite);
export default __webpack_public_path__ + "static/media/shells_logo_vertical_white.9a0f9cbb77a0d83b5b283fea86d7cf6a.svg";
export { ForwardRef as ReactComponent };